import { AliasDataStore, ItemDataStore, LocationDataStore, ThesaurusTermDataStore } from '..';

export const DATASTORES_FROM_TYPE = {
    Alias: AliasDataStore,
    Collaborator: AliasDataStore,
    ThesaurusTerm: ThesaurusTermDataStore,
    numericMuseumItem: ItemDataStore,
    physicalMuseumItem: ItemDataStore,
    Location: LocationDataStore
}